var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var LogoWhite = styled.img.attrs({
    src: '/shared/morressier-logo-white.svg',
    alt: 'Morressier logo white'
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var LogoBlack = styled.img.attrs({
    src: '/shared/morressier-logo-black.svg',
    alt: 'Morressier logo black'
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var LogoIconBlack = styled.img.attrs({
    src: '/shared/morressier-icon-black.svg',
    alt: 'Morressier icon black'
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
export var LogoIconWhite = styled.img.attrs({
    src: '/shared/morressier-icon-white.svg',
    alt: 'Morressier icon white'
})(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map